<template>
  <LeftSide>
    <template v-slot:title>
      {{ title }}
    </template>

    <ReportForm v-if="report" :report="report"/>
  </LeftSide>
</template>

<script>
import LeftSide from '@/views/areas/awards/LeftSide.vue';
import ReportForm from '@/views/areas/awards/reports/partials/ReportForm.vue';

export default {
  name: 'ReportsEdit',
  components: {
    LeftSide,
    ReportForm,
  },
  props: {
    report: {
      type: Object,
    },
  },
  computed: {
    title() {
      return this.report.reportable_type === 'nomination' ? 'Nomination Report' : 'Award Report';
    },
  },
};
</script>
